import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Linkedin, Twitter, Facebook, ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";
import { company, navLinks, services } from "@/mock/mock";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-brand-navy2">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Logo />
            <p className="mt-5 text-sm leading-relaxed text-slate-400">
              {company.legal}. A Halifax-based Managed Security Service Provider delivering 24/7 SOC, digital forensics and cyber defense for Canadian organizations.
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href={company.social.linkedin} aria-label="LinkedIn" className="h-9 w-9 grid place-items-center rounded-full bg-white/5 hover:bg-brand-lime hover:text-brand-navy transition-colors"><Linkedin className="h-4 w-4" /></a>
              <a href={company.social.twitter} aria-label="Twitter" className="h-9 w-9 grid place-items-center rounded-full bg-white/5 hover:bg-brand-lime hover:text-brand-navy transition-colors"><Twitter className="h-4 w-4" /></a>
              <a href={company.social.facebook} aria-label="Facebook" className="h-9 w-9 grid place-items-center rounded-full bg-white/5 hover:bg-brand-lime hover:text-brand-navy transition-colors"><Facebook className="h-4 w-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white">Company</h4>
            <ul className="mt-5 space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="group inline-flex items-center gap-1 text-sm text-slate-400 hover:text-brand-lime transition-colors">
                    <ArrowRight className="h-3.5 w-3.5 opacity-0 -ml-4 group-hover:opacity-100 group-hover:ml-0 transition-all" /> {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white">Services</h4>
            <ul className="mt-5 space-y-3">
              {services.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <Link to="/services" className="text-sm text-slate-400 hover:text-brand-lime transition-colors">{s.title}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-white">Get in touch</h4>
            <ul className="mt-5 space-y-4 text-sm text-slate-400">
              <li className="flex gap-3"><MapPin className="h-5 w-5 shrink-0 text-brand-lime" /> {company.address}</li>
              <li><a href={`mailto:${company.email}`} className="flex gap-3 hover:text-brand-lime transition-colors"><Mail className="h-5 w-5 shrink-0 text-brand-lime" /> {company.email}</a></li>
              <li><a href={`tel:${company.phoneHref}`} className="flex gap-3 hover:text-brand-lime transition-colors"><Phone className="h-5 w-5 shrink-0 text-brand-lime" /> {company.phone}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} {company.legal}. All rights reserved. · NS Business No. {company.businessNumber}</p>
          <p>Proudly serving organizations across Canada from Halifax, Nova Scotia.</p>
        </div>
      </div>
    </footer>
  );
}
